import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import ResponsiveAppBar from "./components/Appbar";
import { ClaimsStepper } from "./components/Stepper";

import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { SupportingDocumentation } from "./pages/SupportingDocumentation";

function AppContent() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uploadDocs = queryParams.get("uploadDocs") === "true";
  const claimId = queryParams.get("claimId") ?? undefined;
  const email = queryParams.get("email") ?? undefined;
  return (
    <Box style={{ maxWidth: "100vw", overflow: "hidden" }}>
      <ResponsiveAppBar />
      {uploadDocs ? (
        <SupportingDocumentation
          isDocumentUploadOnly={true}
          claimId={claimId}
          email={email}
        />
      ) : (
        <ClaimsStepper />
      )}
    </Box>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
